// extracted by mini-css-extract-plugin
export var content = "index-module--content--ZXwgT";
export var sidenav = "index-module--sidenav--3Pa_F";
export var description = "index-module--description--3T8O3";
export var imageRow = "index-module--imageRow--1RMpo";